import React from 'react';
import { oneOf } from 'prop-types';
import { translate } from 'react-i18next';
import { Tooltip, IconButton } from 'wix-style-react';
import Edit from 'wix-ui-icons-common/Edit';
import {
  WIX_BASE_URL,
  ARENA_EDIT_PROFILE_TO_TAB_URL,
} from '../../../utils/constants';
import getBaseName from '../../../utils/getBaseName';
import { baseURL } from '../../../fromWindow';
import s from './editProfileLink.scss';

const EditProfileLink = ({ tabName, t }) => {
  const urlOrigin = `${WIX_BASE_URL}${getBaseName(baseURL)}`;
  return (
    <a
      className={s.editIcon}
      href={`${urlOrigin}${ARENA_EDIT_PROFILE_TO_TAB_URL}${tabName}`}
    >
      <Tooltip
        appendTo="window"
        content={t('expert-expertview-edit-profile-link-tooltip')}
      >
        <IconButton as="button" skin="inverted" priority="secondary">
          <Edit />
        </IconButton>
      </Tooltip>
    </a>
  );
};

EditProfileLink.propTypes = {
  tabName: oneOf(['info', 'about', 'portfolio', 'rates']),
};
EditProfileLink.defaultProps = {
  tabName: 'info',
};

export default translate()(EditProfileLink);
